/**
 * 合作单位API
 */
import axios from 'axios';
import { isDevelopment } from './utils';

// 开发环境使用localhost，生产环境使用完整的API域名
const API_BASE_URL = process.env.REACT_APP_BASE_API_URL || (isDevelopment()
  ? 'http://localhost:5001/api/v1'
  : 'https://api.hammerath.cn/api/v1');

/**
 * 获取显示的合作单位列表
 * @returns {Promise}
 */
export const getVisiblePartners = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/partners`, {
      params: { visible_only: true }
    });
    
    if (response.data && response.data.success) {
      return {
        success: true,
        data: response.data.data || []
      };
    }
    
    return {
      success: false,
      message: response.data?.message || '获取合作单位列表失败',
      data: []
    };
  } catch (error) {
    console.error('获取合作单位列表失败:', error);
    return {
      success: false,
      message: error.message || '网络错误',
      data: []
    };
  }
};


